module.exports = __webpack_public_path__ + "src/assets/games/27/590.jpg";